import { AfterViewInit, Component } from '@angular/core';
import { isTouchDevice } from '@app-collector/utils';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements AfterViewInit {
  title = 'collector';
  touchDevice: boolean = false;

  ngAfterViewInit(): void {
    this.touchDevice = isTouchDevice();
  }

}
